import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { appActions, userActions, validationActions, facebookThunk, iamThunk } from '../../actions';
import { Validation, Intl } from '../../mixins';
import { iamMessages } from '../../config';
import PageBoilerplateDefault from '../../components/page/PageBoilerplateDefault';
import { getRecoverableErrorType } from '../../reducers';
import { setRoute, path } from '../../router';
import {
	DNAInputWithLabel,
	DNAValidationMessage,
	DNAButtonSocial,
	DNAButtonDefault,
} from '../../components';

@Validation
export class EmailPage extends Component {
	static propTypes = {
		updateRoute: PropTypes.func,
		requestSettings: PropTypes.object.isRequired,
		emailPageHeading1: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.string,
		]),
		emailPageFacebookAssuranceMessage: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.string,
		]),
		isAppDisabled: PropTypes.bool,
		facebookLoginStatus: PropTypes.object,
		emailPageContinueButtonLabel: PropTypes.string,
		globalAlertsDecoratorClass: PropTypes.string,
		emailAddress: PropTypes.string,
		mainClassName: PropTypes.string,
		userActions: PropTypes.object,
		facebookRequestInFlight: PropTypes.bool.isRequired,
		iamFacebookRequestInFlight: PropTypes.bool.isRequired,
		iamEmailRequestInFlight: PropTypes.bool.isRequired,
		facebookConnectError: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool,
		]),
		iamEmailCheckError: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool,
		]),
		iamFacebookLoginError: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.bool,
		]),
		loginSuccessCallback: PropTypes.func,
		iamThunk: PropTypes.object.isRequired,
		facebookThunk: PropTypes.object.isRequired,
		// HOCs
		intl: PropTypes.object.isRequired,
		router: PropTypes.object,
		// Decorators
		errors: PropTypes.object,
		propsFromHost: PropTypes.object,
	};
	static defaultProps = {
		errors: {},
		emailAddress: '',
		propsFromHost: {},
	};
	constructor(props) {
		super(props);
		/**
		 * Component-specific UI state
		 */
		// Clear existing alerts
		this.state = {
			alertFacebookLoginError: false,
			alertEmailLoginError: false,
		};

		// Register which fields on the page expected validation
		this.validatedFields = [
			'emailAddress',
		];
	}
	componentWillMount() {
		this.validatedFields.forEach(field => {
			this.hasErrors(field) && this.clearValidation(field);
		});
	}
	componentDidMount() {
		const { propsFromHost } = this.props;

		if (propsFromHost.onEmailPageMount) {
			propsFromHost.onEmailPageMount();
		}
	}
	handleEmailAddressBlur(e) {
		this.validate('emailAddress', e.target.value);
	}
	handleEmailAddressChange(e) {
		const { userActions } = this.props;
		userActions.updateEmailAddress(e.target.value);
	}
	handleContinue() {
		const { emailAddress, propsFromHost } = this.props;

		if (propsFromHost.onLoginWithEmailClicked) {
			propsFromHost.onLoginWithEmailClicked();
		}

		this.isValid('emailAddress', emailAddress) && this.proceed();
	}
	loginWithFacebook(e) {
		const { requestSettings, facebookThunk, loginSuccessCallback, propsFromHost } = this.props;
		if (propsFromHost.onLoginWithFacebookClicked) {
			propsFromHost.onLoginWithFacebookClicked();
		}
		e.preventDefault();
		// Clear existing error alerts
		this.setState({
			alertFacebookLoginError: false,
			alertEmailLoginError: false,
		});
		facebookThunk.facebookLogin(requestSettings)
			.then(loginSuccessCallback)
			.catch(error => {
				if(error !== 'unknown') {
					// Show latest Facebook error alerts
					this.setState({
						alertFacebookLoginError: true,
					});
				}
			});
	}
	getRecoverableError() {
		const { facebookConnectError, iamFacebookLoginError, iamEmailCheckError } = this.props;
		const { alertFacebookLoginError, alertEmailLoginError } = this.state;

		if (alertFacebookLoginError) {
			return facebookConnectError || iamFacebookLoginError;
		} else if (alertEmailLoginError) {
			return iamEmailCheckError;
		}
	}
	proceed() {
		const { iamThunk, updateRoute, router, publicPath } = this.props;

		// Clear existing error alerts
		this.setState({
			alertFacebookLoginError: false,
			alertEmailLoginError: false,
		});
		iamThunk.iamEmailCheck()
			.then(response => {
				response === iamMessages.USER_FOUND && setRoute(updateRoute, router)(path.join(publicPath, 'password'));
				response === iamMessages.NO_USER_FOUND.error && setRoute(updateRoute, router)(path.join(publicPath, 'register'));
			})
			.catch(() => {
				// Show latest email check error alerts
				this.setState({
					alertEmailLoginError: true,
				});
			});
	}
	render() {
		const {
			intl,
			emailPageHeading1,
			emailPageFacebookAssuranceMessage,
			emailAddress,
			errors,
			mainClassName,
			facebookRequestInFlight,
			iamFacebookRequestInFlight,
			iamEmailRequestInFlight,
			emailPageContinueButtonLabel,
			globalAlertsDecoratorClass,
			isAppDisabled,
			facebookLoginStatus,
		} = this.props;

		const isFormButtonDisabled = !::this.isEveryValid() || isAppDisabled || facebookRequestInFlight || iamFacebookRequestInFlight;

		return (
			<PageBoilerplateDefault
				intl={intl}
				globalAlertsDecoratorClass={globalAlertsDecoratorClass}
				HeadingH1Content={emailPageHeading1}
				isRecoverableError={::this.getRecoverableError()}
				mainClassName={mainClassName}
				handleSubmit={::this.handleContinue}>

				<DNAButtonSocial
					buttonState={facebookRequestInFlight || iamFacebookRequestInFlight || !facebookLoginStatus ? 'loading' : ''}
					intl={intl}
					isDisabled={isAppDisabled}
					buttonText={intl.formatMessage('content|login:email|facebookLoginButtonLabel')}
					socialNetwork='Facebook'
					handleClickProp={::this.loginWithFacebook} />

				<p className='login-text-facebook-login dna-text-s'>
					{
						emailPageFacebookAssuranceMessage ||
						intl.formatMessage('content|login:email|facebookAssuranceMessage')
					}
				</p>
				<div className='login-section-divider-email-page'>
					{intl.formatMessage('content|_defaults|or')}
					<span className='dna-invisible'>
						&nbsp;{intl.formatMessage('content|login:email|accessibleEmailLoginText')}
					</span>
				</div>

				<DNAInputWithLabel
					parent={this}
					errorKey='emailAddress'
					handleBlur={::this.handleEmailAddressBlur}
					handleChangeProp={::this.handleEmailAddressChange}
					type='email'
					value={emailAddress}
					id='emailAddress'
					label={intl.formatMessage('content|login:email|emailFieldLabel')}
					sizeVariant='medium'
					errors={errors.emailAddress} />

				<DNAValidationMessage
					intl={ intl }
					wrapperClass='login-validation-message'
					errors={[...errors.emailAddress || []]} />

				<DNAButtonDefault
					intl={intl}
					decoratorClass='dna-button-brand dna-space-mtm'
					buttonState={iamEmailRequestInFlight ? 'loading' : ''}
					handleClick={::this.handleContinue}
					qaSelector='EmailPageContinueButton'
					showDisabled={isFormButtonDisabled}
					isDisabled={isFormButtonDisabled}>
					{ emailPageContinueButtonLabel ? emailPageContinueButtonLabel : intl.formatMessage('content|login:email|defaultContinueButtonLabel')}
				</DNAButtonDefault>

			</PageBoilerplateDefault>
		);
	}
}

export const mapStateToProps = state => {
	const facebookRequestInFlight = state.HTTP_request.facebook_connect && state.HTTP_request.facebook_connect.isInflight ? true : false;
	const iamFacebookRequestInFlight = state.HTTP_request.iam_facebook_login && state.HTTP_request.iam_facebook_login.isInflight ? true : false;
	const iamEmailRequestInFlight = state.HTTP_request.iam_email_check && state.HTTP_request.iam_email_check.isInflight ? true : false;

	return {
		facebookRequestInFlight,
		facebookConnectError: getRecoverableErrorType(state, 'facebook_connect', state.APP_network),
		iamFacebookRequestInFlight,
		iamFacebookLoginError: getRecoverableErrorType(state, 'iam_facebook_login', state.APP_network),
		iamEmailRequestInFlight,
		iamEmailCheckError: getRecoverableErrorType(state, 'iam_email_check', state.APP_network),
		emailAddress: state.emailAddress || '',
		errors: state.VALIDATION_errors,
		propsFromHost: state.propsFromHost,
	};
};

const mapDispatchToProps = dispatch => ({
	userActions: bindActionCreators(userActions, dispatch),
	appActions: bindActionCreators(appActions, dispatch),
	validationActions: bindActionCreators(validationActions, dispatch),
	facebookThunk: bindActionCreators(facebookThunk, dispatch),
	iamThunk: bindActionCreators(iamThunk, dispatch),
});

const EmailPageComposed = Intl(EmailPage);
export const EmailPageWithRouter = connect(mapStateToProps, mapDispatchToProps)(withRouter(EmailPageComposed));
export default connect(mapStateToProps, mapDispatchToProps)(EmailPageComposed);



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/containers/pages/EmailPage.js